import React from 'react';
import { Home } from './pages/Home';
export function App() {
  return <div className="min-h-screen bg-brand-dark text-brand-text selection:bg-brand-gold selection:text-brand-darker" data-id="element-0">
      <Home data-id="element-1" />
    </div>;
}